import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { Subject } from "rxjs";


import { APP_CONFIG } from "../../../../config/config";
import { lightCategoryColors, lightPillarColors, mediumCategoryColors, mediumPillarColors, PillarSlug } from "../../../../thematics/colors";
import { CreateTrainService } from "../../../../thematics/create-train.service";
import { Train } from "../../../../trains/models/train.entity";
import { Sherpa } from "../../../../users/models/sherpa.entity";
import { CreditCheckService } from '../../../services/credit-check.service';
import { formatDate, formatTimeSlot } from "../../../tool-functions/date-tools";

@Component({
  selector: 'app-available-train',
  templateUrl: './available-train.component.html',
  styleUrls: [ './available-train.component.scss' ]
})
export class AvailableTrainComponent implements OnInit, OnDestroy {

  @Input() train!: Train;

  colorMedium!: string;

  colorLight!: string;

  destroys$ = new Subject<void>();

  constructor(@Inject(APP_CONFIG)
              private readonly router: Router,
              private readonly creatTrainService: CreateTrainService,
              private readonly creditCheckService: CreditCheckService) {
  }

  ngOnInit() {
    const thematic = this.train.dynamic.thematic;
    const pillarName = thematic.pillar?.name as PillarSlug;
    const categorySlug = thematic.category?.slug;

    this.colorMedium = categorySlug
      ? mediumCategoryColors[categorySlug]
      : (pillarName ? mediumPillarColors[pillarName] : '');
    this.colorLight = categorySlug
      ? lightCategoryColors[categorySlug]
      : (pillarName ? lightPillarColors[pillarName] : '');
  }

  ngOnDestroy() {
    this.destroys$.next();
  }

  dateFormat = formatDate;

  timeFormat = formatTimeSlot;

  goToSherpa(sherpa: Sherpa): void {
    this.router.navigate([ 'sherpas', sherpa.id ]);
  }

  selectTrain() {
    (window._mtm || []).push({ 'event': 'inscription-parcours-header', 'nom-parcours': this.train.dynamic.thematic.title });
    this.creditCheckService.checkAndNotify(
      this.train.dynamic.type, 
      () => this.creatTrainService.selectTrain(this.train)
    );
  }

}
